import { headers as defaultHeaders } from '@/config/axios';
import axiosRequest from '.';

export const getAllIntakeEvents = async (data) => (
  axiosRequest({
    url: '/v1/intakeEvent/getall',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

export const updateIntakeEvent = async (data) => (
  axiosRequest({
    url: '/v1/intakeEvent/update',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

export const retryFilename = async (data) => (
  axiosRequest({
    url: '/v1/intakeEvent/retryFilename',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

export const getIntakeEventsCount = async (data) => (
  axiosRequest({
    url: '/v1/intakeEvent/count',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);
